import React from "react";
import _ from "lodash";
import { Link } from "react-router-dom";
import { ScatterplotLayer, IconLayer, TextLayer } from "@deck.gl/layers";
import TextareaAutosize from "react-textarea-autosize";
import { Button, FormGroup, Row, Col, Label, Container } from "reactstrap";
import numeral from "numeral";

import DataCombobox from "components/DataCombobox";
import SiteSummaryView from "components/SiteSummaryView";
import StorePlanningMap from "pages/StorePlanning/pages/Map";
import MarketInformationEdit from "../MarketInformationEdit";
import Constant from "../../constants";

import api from "../../api";

import "./index.css";
import Map from "pages/Map";

// The Roster component matches one of two different routes
// depending on the full pathname
export default class MarketInformationDetailScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      site: {
        id: parseInt(this.props.match.params.location_id, 10) || "",
        description: "",
        name: "",
        segment_query: "",
      },
      labelNames: [],
      actions: [],
      isLoading: false,
      isValidating: false,
      isMapObjectClicked: false,
      segmentUserCount: 0,
      validationError: "",
      isAddNewAction: false,
      siteRejectionReasons: [],
      nearbyLocations: [],
      initialViewState: {
        longitude: 0,
        latitude: 0,
        zoom: 15,
        pitch: 0,
        bearing: 0,
      },
      customAttributeData: {},
    };
    this.onViewStateChange = this.onViewStateChange.bind(this);
  }
  UNSAFE_componentWillMount() {
    this.getSiteDetail();
    this.getNearbyLocations();
    this.getSiteRejectionReasons();
  }
  componentDidMount = () => {};
  getSiteDetail() {
    const { site } = this.state;
    this.setState({ isLoading: true });
    api.fetchAPI({
      method: "get",
      uri: `location/${site.id}`,
      success: (response) => {
        const site = response.result;
        this.setState({
          site,
          labelNames: response.label_columns,
          viewState: {
            longitude: site.longitude,
            latitude: site.latitude,
            zoom: 15,
            pitch: 0,
            bearing: 0,
          },
          customAttributeData:
            site && site.custom_attribute_data
              ? JSON.parse(site.custom_attribute_data)
              : {},
        });
        this.setState({ isLoading: false });
      },
      error: (error) => {
        console.error(error);
        this.setState({ isLoading: false });
      },
    });
  }
  getNearbyLocations() {
    const { site } = this.state;
    api.fetchAPI({
      method: "get",
      uri: `location/${site.id}/nearby/`,
      success: (response) => {
        console.log(response.nearby_locations);
        this.setState({
          nearbyLocations: response.nearby_locations,
        });
      },
      error: (error) => {
        console.error(error);
        this.setState({ isLoading: false });
      },
    });
  }
  getSiteRejectionReasons() {
    api.fetchAPI({
      method: "get",
      uri: `site_rejection_reason/`,
      success: async (response) => {
        if (response.result) {
          this.setState({
            siteRejectionReasons: response.result,
          });
        }
      },
      error: (error) => {
        alert(error.msg);
      },
    });
  }
  createNewAction() {
    this.setState({
      isAddNewAction: true,
    });
  }
  changeToDraft() {
    const confirmation = window.confirm(
      `Bạn sẽ đưa mặt bằng này thành bản nháp, khi đó bạn có thể chỉnh sửa?`
    );
    if (!confirmation) return;
    const { site } = this.state;
    site.site_dev_status = "draft";
    this.setState({ site }, this.updateSite);
  }
  hideSite() {
    const confirmation = window.confirm(
      `Ẩn mặt bằng sẽ ẩn vĩnh viễn, không hiện lại ở bất kì đâu. Bạn chắc chứ?`
    );
    if (!confirmation) return;
    const { site } = this.state;
    site.is_active = 0;
    this.setState({ site }, this.updateSite);
  }
  approveSite() {
    const confirmation = window.confirm(`Bạn sẽ duyệt mặt bằng này?`);
    if (!confirmation) return;
    const { site } = this.state;
    api.fetchAPI({
      method: "post",
      uri: `location/${site.id}/approve`,
      success: async (response) => {
        if (response.result) {
          site.site_dev_status = response.result.site_dev_status;
          this.setState({
            site,
          });
        }
      },
      error: (error) => {
        alert(error.message);
        this.setState({ isLoading: false });
      },
    });
  }
  submitSiteForApproval() {
    const confirmation = window.confirm(
      `Bạn sẽ đưa mặt bằng này cho sếp duyệt?`
    );
    if (!confirmation) return;
    const { site } = this.state;
    api.fetchAPI({
      method: "post",
      uri: `location/${site.id}/submit_for_approval`,
      success: async (response) => {
        if (response.result) {
          site.site_dev_status = response.result.site_dev_status;
          this.setState({
            site,
          });
        }
      },
      error: (error) => {
        alert(error.message);
        this.setState({ isLoading: false });
      },
    });
  }
  rejectSite() {
    this.setState({ isRejecting: true });
  }
  setRejectionReason(value) {
    const { site } = this.state;
    site.site_rejection_reason = value;
    this.setState({ site });
  }
  confirmRejectSite() {
    const confirmation = window.confirm(`Bạn sẽ từ chối mặt bằng này?`);
    if (!confirmation) return;
    const { site } = this.state;
    api.fetchAPI({
      method: "post",
      uri: `location/${site.id}/reject`,
      success: async (response) => {
        if (response.result) {
          site.site_dev_status = response.result.site_dev_status;
          this.setState({
            site,
            isRejecting: false,
          });
        }
      },
      error: (error) => {
        alert(error.message);
        this.setState({ isLoading: false });
      },
    });
  }
  updateSite() {
    const { site } = this.state;
    api.fetchAPI({
      method: "put",
      uri: `location/${site.id}`,
      body: site,
      success: async (response) => {
        if (response.result) {
          this.setState({
            site,
            isLoading: false,
          });
        }
      },
      error: (error) => {
        alert(error.msg);
        this.setState({ isLoading: false });
      },
    });
  }
  updateAttr(attribute, value) {
    const { site } = this.state;
    site[attribute] = value;
    this.setState({ site });
  }
  onMapItemHover(hoveredObject, x, y) {
    this.setState({
      hoveredObject,
      pointerX: x,
      pointerY: y,
    });
  }
  onMapItemClick(hoveredObject, x, y) {
    this.setState({
      isMapObjectClicked: true,
      hoveredObject,
      clickedPointerX: x,
      clickedPointerY: y,
    });
  }
  goToInitialLocation() {
    const { site } = this.state;
    const goToViewState = {
      longitude: site.longitude,
      latitude: site.latitude,
      zoom: 15,
      pitch: 0,
      bearing: 0,
      transitionDuration: 500,
    };
    this.setState({ viewState: goToViewState });
  }
  onViewStateChange({ viewState }) {
    this.setState({ viewState });
  }
  _renderTooltip() {
    let {
      hoveredObject,
      pointerX,
      pointerY,
      isMapObjectClicked,
      clickedPointerX,
      clickedPointerY,
    } = this.state || {};
    const { site } = this.state;

    return (
      hoveredObject && (
        <div
          className="map_hover_tooltip"
          style={{
            position: "absolute",
            zIndex: 1,
            left: isMapObjectClicked ? clickedPointerX : pointerX,
            top: isMapObjectClicked ? clickedPointerY : pointerY,
          }}
        >
          {(hoveredObject.brand || hoveredObject.brand_name) && (
            <span className="map_hover_tooltip_text brand">
              {hoveredObject.brand_name || hoveredObject.brand.name}
              <br />
            </span>
          )}
          {site.id == hoveredObject.id && (
            <span className="map_hover_tooltip_text selected-location">
              Địa điểm đang chọn
              <br />
            </span>
          )}
          <span className="map_hover_tooltip_text">
            {hoveredObject.address ||
              hoveredObject.full_address ||
              hoveredObject.name ||
              ""}
          </span>
          <br />
          {hoveredObject.location_type && (
            <span className="map_hover_tooltip_text">
              Type:{" "}
              {hoveredObject.location_type_name ||
                hoveredObject.location_type.name}
              <br />
            </span>
          )}
          {hoveredObject.distance_in_km && (
            <span className="map_hover_tooltip_text">
              Distance:{" "}
              {numeral(hoveredObject.distance_in_km * 1000).format("0,00")} m
            </span>
          )}
        </div>
      )
    );
  }
  render() {
    const {
      site,
      labelNames,
      isRejecting,
      isLoading,
      nearbyLocations,
      viewState,
      isMapObjectClicked,
      hoveredObject,
      customAttributeData,
    } = this.state;
    if (!site) return null;
    if (isLoading) return <div>Đang tải...</div>;

    let validLatLng = true;
    // Validate lat lng to avoid app crashing
    if (site.latitude < -90 || site.latitude > 90) {
      validLatLng = false;
    }

    if (site.longitude < -180 || site.longitude > 180) {
      validLatLng = false;
    }

    // Build view data
    const mapLayers = [
      // Layer for the selected location
      new ScatterplotLayer({
        id: "main-location-layer",
        data: [
          {
            address: site.full_address,
            coordinates: [site.longitude, site.latitude],
            ...site,
          },
        ],
        pickable: true,
        opacity: 0.8,
        stroked: true,
        filled: true,
        radiusScale: 9,
        radiusMinPixels: 10,
        radiusMaxPixels: 100,
        lineWidthMinPixels: 6,
        getPosition: (d) => d.coordinates,
        getRadius: 3,
        getFillColor: (d) => [226, 255, 14],
        getLineColor: (d) => [18, 217, 252],
        onHover: (info) =>
          this.setState({
            hoveredObject: info.object,
            pointerX: info.x,
            pointerY: info.y,
          }),
      }),
    ];

    if (nearbyLocations) {
      mapLayers.push(
        // Layer for near by location
        new ScatterplotLayer({
          id: "nearby-location-layer",
          data: nearbyLocations
            .filter((nearbyLocation) => nearbyLocation.id !== site.id)
            .map((nearbyLocation) => {
              return {
                name: nearbyLocation.name,
                address: nearbyLocation.name,
                coordinates: [
                  nearbyLocation.longitude,
                  nearbyLocation.latitude,
                ],
                ...nearbyLocation,
              };
            }),
          pickable: true,
          opacity: 0.6,
          stroked: false,
          filled: true,
          radiusScale: 6,
          radiusMinPixels: 10,
          radiusMaxPixels: 100,
          getPosition: (d) => d.coordinates,
          getRadius: 1,
          getFillColor: (d) => d.rgba_color_normalized,
          onHover: (info) =>
            !isMapObjectClicked &&
            this.onMapItemHover(info.object, info.x, info.y),
          onClick: (info) => this.onMapItemClick(info.object, info.x, info.y),
        }),
        // Layer for brand logo
        new IconLayer({
          id: "nearby-location-logo-layer",
          data: nearbyLocations
            .filter(
              (nearbyLocation) =>
                nearbyLocation.brand_logo_image && nearbyLocation.id !== site.id
            )
            .map((nearbyLocation) => {
              if (nearbyLocation.brand_logo_image) {
                return {
                  name: nearbyLocation.name,
                  address: nearbyLocation.name,
                  coordinates: [
                    nearbyLocation.longitude,
                    nearbyLocation.latitude,
                  ],
                  ...nearbyLocation,
                };
              }
            }),
          getIcon: (d) => ({
            url: d.brand_logo_image || "",
            width: 64,
            height: 64,
            id: d.id,
          }),
          getSize: 32,
          sizeScale: 1,
          getPosition: (d) => d.coordinates,
          pickable: true,
          onHover: (info) =>
            !isMapObjectClicked &&
            this.onMapItemHover(info.object, info.x, info.y),
          onClick: (info) => this.onMapItemClick(info.object, info.x, info.y),
        }),
        // Text Layer to Display Site Dev Status
        new TextLayer({
          id: "nearby-location-site-dev-text-layer",
          data: nearbyLocations
            .filter(
              (nearbyLocation) =>
                nearbyLocation.is_site_dev_location &&
                nearbyLocation.status != "complete"
            )
            .map((nearbyLocation) => {
              return {
                name: nearbyLocation.name,
                address: nearbyLocation.name,
                coordinates: [
                  nearbyLocation.longitude,
                  nearbyLocation.latitude,
                ],
                ...nearbyLocation,
              };
            }),
          getText: (d) => d.site_dev_status,
          getSize: 24,
          getTextAnchor: "middle",
          getAlignmentBaseline: "top",
          getPixelOffset: [0, 20],
          getColor: [255, 255, 255, 255],
          sizeScale: 1,
          fontFamily: "Arial",
          getPosition: (d) => d.coordinates,
          pickable: true,
          onHover: (info) =>
            !isMapObjectClicked &&
            this.onMapItemHover(info.object, info.x, info.y),
          onClick: (info) => this.onMapItemClick(info.object, info.x, info.y),
        })
      );
    }
    return (
      <Container>
        <div className="site-detail__wrapper">
          <div className="site-detail_summary">
            <div className="site-detail_site-name">
              {site.brand && site.brand && site.brand.brand_logo_image && (
                <img
                  src={site.brand.brand_logo_image}
                  alt={site.brand.name}
                  className="site-detail_brand-logo"
                />
              )}
              {site.name && (
                <span className="site-detail__site-name">{site.name}</span>
              )}
              {site.external_status && (
                <span className={`site-status-label ${site.external_status}`}>
                  {site.external_status}
                </span>
              )}
            </div>
            <p className="site-detail__full-address">
              {site.address_number && site.street_name ? (
                <span>
                  {site.full_address &&
                    `${labelNames.full_address}: ${site.full_address}`}
                </span>
              ) : (
                <span>{site.address}</span>
              )}
            </p>
            {site.location_type?.id === 12 && (
              <p className="site-detail__full-address">
                Doanh thu dự đoán:{" "}
                {customAttributeData.forecasted_revenue
                  ? customAttributeData.forecasted_revenue
                  : customAttributeData.number_of_casiers == 2
                  ? "Dưới 2 tỷ"
                  : customAttributeData.number_of_casiers == 3 ||
                    customAttributeData.number_of_casiers == 4
                  ? "Dưới 3 tỷ"
                  : "Chưa xác định"}
              </p>
            )}
            {/* <p className="site-detail_metric-single">
              <b>Diện tích</b>: {site.area} m2
            </p> */}
            {/* <p className="site-detail_metric-single"><b>Giá chủ mặt bằng chào</b>: {numeral(site.lease_rate).format('0,0')} VND</p>
                        <SiteFinancialProjection site={site} showSummaryOnly />
                        <p className="site-detail_metric-single"><b>Visibility</b>: <span className={`site-detail_metric-visibility ${site.visibility}`}>{site.visibility}</span></p>
                        <p className="site-detail_metric-single"><b>Accessibility</b>: <span className={`site-detail_metric-accessibility ${site.accessibility}`}>{site.accessibility}</span></p> */}
          </div>
          {!isRejecting && (
            <Row>
              <Col xs={12}>
                {site.permissions && (
                  <div className="site-detail__main-controls">
                    {site.permissions.includes("can_put") && (
                      <div>
                        <Button
                          size="sm"
                          tag={Link}
                          to={`/market_information/${site.id}/edit`}
                          onClick={() => this.rejectSite()}
                          color="primary"
                          className="site-detail__button-control"
                        >
                          Chỉnh sửa
                        </Button>
                      </div>
                    )}
                    {site.permissions.includes("can_deactivate_site") && (
                      <Button
                        size="sm"
                        onClick={() => this.hideSite()}
                        color="secondary"
                        className="site-detail__button-control"
                      >
                        Ẩn mặt bằng
                      </Button>
                    )}
                  </div>
                )}
              </Col>
            </Row>
          )}
          <Row>
            {isRejecting && (
              <Col xs={12} className="site-detail__rejection-reason-container">
                <FormGroup>
                  <h3>Lý do từ chối</h3>
                  <DataCombobox
                    apiUrl={"site_rejection_reason/"}
                    onChange={(value) => this.setRejectionReason(value)}
                    value={{
                      label: site.site_rejection_reason
                        ? site.site_rejection_reason.name
                        : "",
                      value: site.site_rejection_reason
                        ? site.site_rejection_reason.id
                        : "",
                    }}
                    placeholder="Lý do từ chối"
                  />
                </FormGroup>
                <Label>Ghi chú thêm về lý do hủy</Label>
                <FormGroup>
                  <TextareaAutosize
                    type="textarea"
                    className="custom-textarea"
                    onChange={(e) =>
                      this.updateAttr("reject_reason", e.target.value)
                    }
                    value={site.reject_reason}
                    placeholder="Ghi chú thêm cho việc từ chối"
                    minRows={3}
                  />
                </FormGroup>
                <FormGroup>
                  <Button
                    onClick={() => this.confirmRejectSite()}
                    color="danger"
                    disabled={site.site_rejection_reason ? false : true}
                  >
                    Tiếp tục
                  </Button>{" "}
                  <Button
                    onClick={() => this.setState({ isRejecting: false })}
                    color="secondary"
                    disabled={site.site_rejection_reason ? false : true}
                  >
                    Quay lại
                  </Button>
                </FormGroup>
              </Col>
            )}
          </Row>
          {/* <Row className="site-detail__images">
            {constants.SITE_IMAGE_ATTRIBUTES.map((imageAttribute) => (
              <Col xs={12} sm={6} key={imageAttribute}>
                {site.photos && (
                  <div className="site-edit__img-container">
                    <Label>{labelNames[imageAttribute]}</Label>
                    {site.photos[imageAttribute] &&
                      site.photos[imageAttribute]["url"] && (
                        <img
                          className="site-edit__img"
                          src={site.photos[imageAttribute]["url"]}
                        />
                      )}
                    {site.photos[imageAttribute] &&
                      site.photos[imageAttribute]["caption_text"] && (
                        <p className="site-edit__caption">
                          {site.photos[imageAttribute]["caption_text"]}
                        </p>
                      )}
                  </div>
                )}
              </Col>
            ))}
          </Row> */}
          {validLatLng && site.latitude && site.longitude ? (
            <Row>
              <Col xs={12}>
                {!isMapObjectClicked ? (
                  <Map
                    latitude={viewState.latitude}
                    longitude={viewState.longitude}
                    embedMode
                  />
                ) : (
                  <SiteSummaryView
                    site={hoveredObject}
                    onBackClick={() =>
                      this.setState({ isMapObjectClicked: false })
                    }
                  />
                )}
              </Col>
            </Row>
          ) : (
            <Row>
              <Col xs={12}>
                <p>Map will not show due to missing or invalid lat, lng...</p>
              </Col>
            </Row>
          )}
          <br />
          <MarketInformationEdit
            match={{ params: { location_id: site.id } }}
            site={site}
            labelNames={labelNames}
            isView
          />
        </div>
      </Container>
    );
  }
}
